import {useState, useEffect, useCallback} from 'react';
import type {RefObject} from 'react';
import type {AcaAppElement} from '@/shared/types/AcaAppElement';

interface SignedInChangedEvent extends CustomEvent {
    detail: {
        signedIn: boolean;
    };
}

export const useAcaAppLitElement = (litRef: RefObject<AcaAppElement | null>) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleSignedInChanged = useCallback((event: Event) => {
        const customEvent = event as SignedInChangedEvent;

        if (window.location.pathname !== '/callback') {
            setIsVisible(customEvent.detail.signedIn);
        }
    }, []);

    useEffect(() => {
        const litElement = litRef.current;

        if (litElement) {
            if (litElement.signedIn) {
                litElement._settings.mainMenu;
                litElement._settings.adminMenu;

                window.setTimeout(() => {
                    setIsVisible(true);
                    litElement.style.position = 'static';
                }, 1500);
            }

            // Add event listeners
            litElement.addEventListener('signed-in-changed', handleSignedInChanged);
        }

        return () => {
            if (litElement) {
                litElement.removeEventListener('signed-in-changed', handleSignedInChanged);
            }
        };
    }, [litRef]);

    return {
        isVisible,
    };
};
